import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
// A Inter via bundle mantém a tipografia disponível sem requisições externas.
import "@fontsource-variable/inter";
import "./estilos/global.css";

const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Uma repetição só: se a API está fora, insistir apenas atrasa a tela de erro.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

const raiz = document.getElementById("raiz");
if (!raiz) {
  throw new Error("Elemento #raiz não encontrado em index.html.");
}

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteDeConsultas}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
